<template>
  <transition name="fade">
    <div v-if="customerId && customerIsSignedUpForSmsMarketing" class="col-12 col-md-6 account-data-col viber-sign-out">
      <div class="account-data-col-in">
        <p v-html="t('viber.sign.out.title')"></p>
        <div class="account-data-action viber-sign-out-action">
          <button
            type="button"
            class="viber-sign-out-button"
            :aria-label="t('viber.signOut')"
            @click="signOutViber"
            :disabled="isLoading"
            :style="{
              'grid-template-columns': isLoading ? 'auto' : 'auto 1fr',
              'gap': isLoading ? '0' : '5px'
            }"
          >
            <i v-show="!isLoading" class="lni lni-trash"></i>
            <span v-show="!isLoading" class="viber-sign-out-button-text">{{ t('viber.sign.out.button.text') }}</span>
            <span v-if="isLoading" class="loader"></span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ViberSignOut',
  props: {
    customerId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      customerIsSignedUpForSmsMarketing: false,
      error: '',
      isLoading: false
    }
  },
  async created () {
    await axios
      .get('/api/customer/getCustomerIsSignedUpViber')
      .then((response) => {
        this.customerIsSignedUpForSmsMarketing = response.data.isSignedUpViber
      })
      .catch(() => {
        this.customerIsSignedUpForSmsMarketing = false
      })
  },
  methods: {
    signOutViber () {
      this.isLoading = true
      axios
        .post('/api/customer/setViberPhone', {
          addToViber: false
        })
        .then((response) => {
          const responseMessage = response.data.detail
          this.$toasted.success(responseMessage)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter, .fade-leave-to { opacity: 0 }
.fade-leave, .fade-enter-to { opacity: 1 }
.fade-enter-active, .fade-leave-active { transition: opacity 1000ms }

.loader {
  position: relative;
  display: grid;
  border: 6px solid #f3f3f3;
  border-radius: 50%;
  border-top: 6px solid #3498db;
  width: 26px;
  height: 26px;
  animation: spin 2s linear infinite;
  justify-items: center;
  align-items: center;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.viber-sign-out {
  margin-top: 10px;
}

.viber-sign-out-button {
  width: 100%;
  font-size: 13px;
  background: #E0E0E0;
  color: #0d1010;
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 5px 15px;
  border-radius: 3px;
  border: unset;
  .lni {
    margin: 0;
  }
}
.viber-sign-out-button-text {
  width: 100%;
  text-align: start;
}
.viber-sign-out-action {
  display: block;
  width: 50%;
}
</style>
